import { Flex } from '@/components/Grid';
import { Icon } from '@/components/Icon';
import { AdActivityItemType, AdCategoryItemType } from '@/resource/ad';
import { Fragment, useState } from 'react';
import { Button } from '@/components/Button';
import { Heading } from '@/components/Heading';

type Props = {
  categories: AdCategoryItemType[];
  selected: AdActivityItemType[];
  maxSelect: number;
  onToggle: (activity: AdActivityItemType) => void;
};

export function ActivitySelect({
  categories,
  selected,
  maxSelect = 4,
  onToggle,
}: Props) {
  const [openCategoryIds, setOpenCategoryIds] = useState<number[]>([]);
  const activityIds = selected.map((activity) => activity.id);

  return (
    <Flex dir="column" gap={2}>
      {categories
        .filter((category) => (category.activities?.data || []).length > 0)
        .map((category) => {
          const isOpen = openCategoryIds.includes(category.id);
          const activities = category.activities?.data || [];
          const count = activities.filter((activity) =>
            activityIds.includes(activity.id)
          ).length;

          const toggleOpen = () =>
            setOpenCategoryIds((ids) =>
              ids.includes(category.id)
                ? ids.filter((id) => id !== category.id)
                : ids.concat([category.id])
            );

          return (
            <Fragment key={category.id}>
              <Flex dir="column" gap={2}>
                <Flex
                  align="center"
                  gap={2}
                  justify="space-between"
                  onClick={toggleOpen}
                >
                  <Flex align="center" gap={2}>
                    <Icon icon={category.icon} />
                    <Heading level={3} visualLevel={4}>
                      {category.name} {count > 0 ? `(${count})` : ''}
                    </Heading>
                  </Flex>

                  <Icon icon={isOpen ? 'chevron_up' : 'chevron_down'} />
                </Flex>

                {isOpen && (
                  <Flex wrap>
                    {activities.map((activity) => (
                      <Button
                        key={activity.id}
                        shape="square"
                        disabled={
                          !activityIds.includes(activity.id) &&
                          activityIds.length >= maxSelect
                        }
                        theme={
                          activityIds.includes(activity.id)
                            ? 'primary'
                            : 'secondary'
                        }
                        onClick={() => onToggle(activity)}
                      >
                        {activity.name}
                      </Button>
                    ))}
                  </Flex>
                )}
              </Flex>
              <hr />
            </Fragment>
          );
        })}
    </Flex>
  );
}
